/**
 * Filter shape for the approval requests queue. Like the invoice filters, this
 * object is what the panel edits and what `buildApprovalRequestQuery` turns into
 * request parameters — the filtering itself happens on the server.
 *
 * Covers every query parameter `/invoices/to-approve` accepts. The panel
 * originally exposed only the date, amount and assignee subset, so the other
 * eight the endpoint supports were unreachable from the UI.
 */
export const EMPTY_APPROVAL_REQUEST_FILTERS = {
  reviewStatusIds: [],
  processingStatusIds: [],
  reviewTypeIds: [],
  failureTypes: [],
  createdOnAfter: "",
  createdOnBefore: "",
  updatedOnAfter: "",
  updatedOnBefore: "",
  totalMin: "",
  totalMax: "",
  assignedToId: "",
  createdById: "",
  updatedById: "",
};

/** The array-valued keys, which need copying rather than sharing on clone. */
export const APPROVAL_LIST_FILTER_KEYS = [
  "reviewStatusIds",
  "processingStatusIds",
  "reviewTypeIds",
  "failureTypes",
];

const APPROVAL_SCALAR_FILTER_KEYS = [
  "createdOnAfter",
  "createdOnBefore",
  "updatedOnAfter",
  "updatedOnBefore",
  "totalMin",
  "totalMax",
  "assignedToId",
  "createdById",
  "updatedById",
];

export function cloneApprovalRequestFilters(filters = EMPTY_APPROVAL_REQUEST_FILTERS) {
  const clone = { ...EMPTY_APPROVAL_REQUEST_FILTERS, ...filters };
  APPROVAL_LIST_FILTER_KEYS.forEach((key) => {
    clone[key] = [...(filters?.[key] ?? [])];
  });
  return clone;
}

export function countApprovalRequestFilters(filters) {
  if (!filters) return 0;

  const listCount = APPROVAL_LIST_FILTER_KEYS.reduce(
    (count, key) => count + (filters[key]?.length ?? 0),
    0,
  );

  return APPROVAL_SCALAR_FILTER_KEYS.reduce(
    (count, key) => (filters[key] !== "" && filters[key] != null ? count + 1 : count),
    listCount,
  );
}
